import * as lscache from "lscache";

import {TEMPORARY_PROPERTIES_FILTERS} from "../../app/constants/storage_keys";

export const getLocalStoragePropertyFilters = (): Record<string, string> => {
    const filters = JSON.parse(lscache.get(TEMPORARY_PROPERTIES_FILTERS));
    if (!filters) {
        return {};
    }
    return filters;
};

export const updateLocalStoragePropertyFilters = (queryValues: Record<string, number | string | string[]>) => {
    lscache.set(TEMPORARY_PROPERTIES_FILTERS, JSON.stringify(queryValues));
};
import * as lscache from "lscache";

import {TEMPORARY_PROPERTIES_FILTERS} from "../../app/constants/storage_keys";

export const getLocalStoragePropertyFilters = (): Record<string, string> => {
    const filters = JSON.parse(lscache.get(TEMPORARY_PROPERTIES_FILTERS));
    if (!filters) {
        return {};
    }
    return filters;
};

export const updateLocalStoragePropertyFilters = (queryValues: Record<string, number | string | string[]>) => {
    lscache.set(TEMPORARY_PROPERTIES_FILTERS, JSON.stringify(queryValues));
};
